const modalToggle = document.querySelector(".modal-toggle")
const modal = document.querySelector(".modal")
const closeModal = document.querySelector(".modal-close")
const backdrop = document.querySelector(".modal-backdrop")

// Create a reusable function to close the modal
function closeModalFunction() {
  if (modal && backdrop) {
    // Hide modal and backdrop - first remove class to trigger opacity transition
    modal.classList.remove("is-visible")
    backdrop.classList.remove("is-visible")
    document.body.classList.remove("no-scroll")
    // Wait for transition to complete before hiding
    setTimeout(() => {
      modal.style.display = "none"
      backdrop.style.display = "none"
    }, 300) // Match this to the transition duration in CSS
  }
}

// Make the function globally available
window.closeModalFunction = closeModalFunction

if (modalToggle) {
  modalToggle.addEventListener("click", function (e) {
    e.preventDefault()
    if (!modal.classList.contains("is-visible")) {
      // Show modal and backdrop
      modal.style.display = "flex"
      backdrop.style.display = "block"
      // Force browser to recognize the display change before applying opacity
      setTimeout(() => {
        modal.classList.add("is-visible")
        backdrop.classList.add("is-visible")
        document.body.classList.add("no-scroll")
      }, 10)
    } else {
      // Hide modal and backdrop - first remove class to trigger opacity transition
      closeModalFunction()
    }
  })
}

if (closeModal) {
  closeModal.addEventListener("click", function (e) {
    e.preventDefault()
    closeModalFunction()
  })
}

// Close modal when clicking on backdrop
if (backdrop) {
  backdrop.addEventListener("click", function () {
    closeModalFunction()
  })
}
